export default __webpack_public_path__ + "static/media/webpage_graphic.5bbea1d6.svg";